import type { ActionDecision } from "../api/action-capabilities";

// Immutable adapter enum order; this is distinct from API provider approval.
export const adapterReadinessNames = ["READY", "CONSUMER_NOT_BOUND", "COORDINATOR_CODE_MISMATCH",
  "COORDINATOR_QUERY_FAILED", "COORDINATOR_PAUSED", "PROVIDER_NOT_REGISTERED", "PROVIDER_CHAIN_EXHAUSTED",
  "PROVIDER_CAPACITY_EXHAUSTED", "PROVIDER_FEE_ABOVE_MAXIMUM", "INSUFFICIENT_RANDOMNESS_BUDGET"] as const;

export const readinessExplanations: Record<typeof adapterReadinessNames[number], string> = {
  READY: "The randomness adapter is ready. Backend permission and provider approval are still required.",
  CONSUMER_NOT_BOUND: "The randomness adapter is not bound to the NFT collection. The operator must complete its configuration.",
  COORDINATOR_CODE_MISMATCH: "The coordinator code does not match the configured deployment. The operator must verify the configuration.",
  COORDINATOR_QUERY_FAILED: "Coordinator state could not be read. Refresh readiness before trying again.",
  COORDINATOR_PAUSED: "The randomness coordinator is paused. Wait for the operator to resume it.",
  PROVIDER_NOT_REGISTERED: "The randomness provider has not been registered with the coordinator.",
  PROVIDER_CHAIN_EXHAUSTED: "The provider's randomness sequence is exhausted. The provider must replenish it.",
  PROVIDER_CAPACITY_EXHAUSTED: "The randomness provider has no remaining request capacity. Wait for capacity to recover.",
  PROVIDER_FEE_ABOVE_MAXIMUM: "The randomness request fee exceeds the adapter's configured maximum.",
  INSUFFICIENT_RANDOMNESS_BUDGET: "The adapter needs more funds to pay for randomness requests.",
};

export function adapterReadinessDecision(value: unknown): ActionDecision {
  const name = typeof value === "number" && Number.isInteger(value) ? adapterReadinessNames[value] :
    typeof value === "string" && adapterReadinessNames.some((name) => name === value) ? value : undefined;
  if (!name) return { state: "UNKNOWN", reasons: ["RANDOMNESS_READINESS_UNCONFIRMED"] };
  return name === "READY" ? { state: "ALLOWED", reasons: [] } : { state: "BLOCKED", reasons: [name] };
}
